export function matchingImpactAuditSuffix(opts: {
  tier: "free" | "warning" | "locked";
  hasAffectedMonths: boolean;
  adminActs: boolean;
  manualConfirmationRequired?: boolean;
}): string | null {
  if (opts.tier !== "warning" || !opts.hasAffectedMonths) return null;
  if (!opts.adminActs) return " · books only after admin approval";
  // Fail closed across a rolling deploy: only an explicit server `false`
  // promises automatic audit. An older/malformed response still warns.
  return opts.manualConfirmationRequired !== false
    ? " · will ask to confirm"
    : " · audit trail recorded automatically";
}
